import React from "react";
import { motion } from "framer-motion";
import "../about.css";
import AboutVM from "../Component/AboutVM";
import SuccessStats from "../Component/SuccessStats";

export default function AboutPage() {
    
  return (
    <>
    <div className="about-wrapper">
      <motion.div 
        className="about-hero"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        {/* <h1>About Us</h1> */}
        <p>We're more than a story: we're a journey</p>
      </motion.div>

      {/* ---- CONTENT SECTION ---- */}
      <motion.div 
        className="about-content"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <h2>Who We Are</h2>
        <p>
      <b>Acadme — One Click. Endless Learning.</b> Acadme is where modern education meets real-world experience. We create a learning journey that goes beyond theory—combining expert-led courses, hands-on internships, and industry-aligned skills to prepare students for the careers of tomorrow.

Whether you're a school student, college learner, working professional, or parent seeking trusted guidance, Acadme provides practical, personalized, and impactful learning designed for real growth. Every program is built to help learners apply their knowledge, gain confidence, and stand out in a competitive world.

With one click, students unlock endless opportunities, real experience, and skills that truly matter.

Acadme — shaping futures through learning that works.
        </p>
      </motion.div>

    </div>

    <AboutVM/>
    <SuccessStats/>
    </>
  );
}
